// Folds case and accents, and spells umlauts both ways — "muller", "müller" and "mueller" all
// find "Müller". Search on both forms.
export const fold = (s: string) =>
    s
        .toLowerCase()
        .replace(/ß/g, "ss")
        .normalize("NFD")
        // Combining accents, as escapes — raw characters break when a script is served without a UTF-8 charset.
        .replace(/[̀-ͯ]/g, "");

export const foldExpanded = (s: string) =>
    s.toLowerCase().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
